import { ProfileDto, ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto as fromProfileDto, toDto as toProfileDto } from '../../../models/adapters/ProfileAdapter';
import { profileSaved, profileSaveFailed, saveProfile, SaveProfileActionType } from '../../actions/setting/saveProfile';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* saveProfileSaga({ payload }: SaveProfileActionType) {
  const { profile } = payload;
  const token = yield getAuthenticationToken();
  const profileDto = toProfileDto(profile);
  const response: { error: string; profile: ProfileDto } = yield getProtectedResponse(ProtectedServerPlaceEvent.updatePlaceProfile, token, { profileDto });
  const timestamp = moment();
  if (!response.error) {
    yield put(profileSaved({ profile: fromProfileDto(response.profile), timestamp }));
  } else {
    yield put(profileSaveFailed({ placeUuid: profile.placeUuid, profileUuid: profile.uuid, timestamp }));
  }
}

export default function* watchSaveProfileSaga() {
  yield takeEvery(saveProfile, saveProfileSaga);
}
